import { WidgetOtherOptions, WidgetType, WidgetVisibility } from "src/app/core/models/constants";
import { GridItem } from "./grid-item";
import { EntityName } from "src/app/core/models/enumerations/entity-name";

export class Widget {
    widgetType: string;
    title: string;
    posHorizonal: number;
    posVertical: number;
    entitiesFilter: Array<string>;
    itemCount: number
    info: string;
    showReload: boolean;
    isFullScreen: boolean;
    visibility: string;
    gridItem: GridItem;
    otherOptions!: string;

    private constructor(
        widgetType: string,
        title: string,
        height: number,
        width: number,
        posHorizonal: number,
        posVertical: number,
        entitiesFilter: Array<string>,
        itemCount: number,
        info: string,
        showReload: boolean,
        isFullScreen: boolean,
        visibility: string
    ) {
        this.widgetType = widgetType;
        this.title = title;
        this.posHorizonal = posHorizonal;
        this.posVertical = posVertical;
        this.entitiesFilter = entitiesFilter;
        this.itemCount = itemCount;
        this.info = info;
        this.showReload = showReload;
        this.isFullScreen = isFullScreen;
        this.visibility = visibility;
        this.gridItem = {
            'cols': width,
            'rows': height,
            'y': this.posVertical,
            'x': this.posHorizonal,
            'widgetType': this.widgetType, 'title': this.title,
            'initialRows' : height
        };
    }
    
    isMinimized(): boolean {
       return this.visibility === WidgetVisibility.Collapsed;
    }

    getSerializedOption(): string {
        let result: string = WidgetOtherOptions.ENTITIES_FILTER+'='+(this.entitiesFilter ? this.entitiesFilter.join(',') : '')+';';
        result += WidgetOtherOptions.HEIGHT+'='+(this.visibility === WidgetVisibility.Collapsed ? this.gridItem.initialRows : this.gridItem.rows)+';';
        result += WidgetOtherOptions.WIDTH+'='+this.gridItem.cols+'';
        return result;
    }

    static BuildWidget(entity: Array<any>): Array<Widget> {
        return entity.map(item => Widget.CreateInstance(item));
    }

    static CreateInstance(record: any): Widget {
        let options = Widget.DeserializeOtherOptions(record.OTHER_OPTIONS);
        let widgetDef: any = Widget.getAvailableWidgets().find((element: any) => element.widgetType === record.SETTING_NAME);
        return new Widget(  record.SETTING_NAME,
                            widgetDef?.title, 
                            options[WidgetOtherOptions.HEIGHT],
                            options[WidgetOtherOptions.WIDTH], 
                            record.POSITION_HORIZONTAL,
                            record.POSITION_VERTICAL,
                            options[WidgetOtherOptions.ENTITIES_FILTER],
                            Number(record.ITEM_COUNT),
                            widgetDef?.info,
                            widgetDef?.showReload, 
                            false,
                            record.VISIBILITY);
    }

    static DeserializeOtherOptions(otherOptions: string): any{
        let result: Record<string, string[] | number> = {};
        if(otherOptions){
            let options: Array<string> = otherOptions.split(';');
            if(options.length > 0){
                options.forEach(option =>{
                    if(option.includes(WidgetOtherOptions.ENTITIES_FILTER)){
                        let filter = option.substring(option.indexOf('=')+1,option.length);
                        if(filter && filter !== ''){
                            result[WidgetOtherOptions.ENTITIES_FILTER] = option.substring(option.indexOf('=')+1,option.length).split(',');
                        }
                    }
                    if(option.includes(WidgetOtherOptions.HEIGHT)){
                        result[WidgetOtherOptions.HEIGHT] = Number(option.substring(option.indexOf('=')+1,option.length));
                    }
                    if(option.includes(WidgetOtherOptions.WIDTH)){
                        result[WidgetOtherOptions.WIDTH] = Number(option.substring(option.indexOf('=')+1,option.length));
                    }
                });
            }
        }
        return result;
    }

    static getDefaultWizardSetting(): any {
        return new Widget (
                WidgetType.Wizard,'', 0, 0, 0, 0, [], 0, '', false, false, WidgetVisibility.Collapsed);
    }

    static getAvailableWidgets(): any {
        return [
            new Widget (
                WidgetType.QuickAccess,
                'widgets.quickAccess.title', 5, 6, 0, 0, [], 10,
                'widgets.quickAccess.info',
                false, false, WidgetVisibility.Expanded
            ),
            new Widget (
                WidgetType.PendingRelease,
                'widgets.pendingRelease.title', 5, 6, 0, 0, [], 10,
                'widgets.pendingRelease.info',
                true, false, WidgetVisibility.Expanded
            ),
            new Widget (
                WidgetType.RecentlyOpened,
                'widgets.recentlyOpened.title', 5, 6, 0, 0, [], 10,
                'widgets.recentlyOpened.info',
                true, false, WidgetVisibility.Expanded
            ),
            new Widget (
                WidgetType.WorkInProgress,
                'widgets.workInProgress.title', 5, 6, 0, 0, [], 10,
                'widgets.workInProgress.info',
                true, false, WidgetVisibility.Expanded
            )
        ];
    }

    static getEntitySettings(): Array<any> {
        return [
                {"name": EntityName.SITE, "id": EntityName.SITE},
                {"name": EntityName.UNIT, "id": EntityName.UNIT},
                {"name": EntityName.PROJECT_CONFIRMED, "id": EntityName.PROJECT_CONFIRMED},
                {"name": EntityName.TANK, "id": EntityName.TANK},
                {"name": EntityName.OFFLINE_EVENT, "id": EntityName.OFFLINE_EVENT},
                {"name": EntityName.BOILER, "id": EntityName.BOILER},
                {"name": EntityName.PLANT_LTSA, "id": EntityName.PLANT_LTSA},
                {"name": EntityName.OEQUIPMENT, "id": EntityName.OEQUIPMENT},
                {"name": EntityName.TURBINE, "id": EntityName.TURBINE},
                {"name": EntityName.UNIT_LTSA, "id": EntityName.UNIT_LTSA},
                {"name": EntityName.PIPELINE_LTSA, "id": EntityName.PIPELINE_LTSA},
                {"name": EntityName.PLANT, "id": EntityName.PLANT},
                {"name": EntityName.ASSET_PIPELINE, "id": EntityName.ASSET_PIPELINE},
                {"name": EntityName.ASSET_TRANSMISSION_LINE, "id": EntityName.ASSET_TRANSMISSION_LINE},
                {"name": EntityName.COMPANY, "id": EntityName.COMPANY},
                {"name": EntityName.AREA, "id": EntityName.AREA},
                {"name": EntityName.PROJECT_UNCONFIRMED, "id": EntityName.PROJECT_UNCONFIRMED},
                {"name": EntityName.MEQUIPMENT, "id": EntityName.MEQUIPMENT}
            ];
    }
}